import { httpClient, HttpError } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import { TaskType } from "../enums/taskTypes";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

interface TaskByIdAndTypeResponse {
  id: string;
  product_article_id: string;
  state: string;
  finished_at: string;
  [key: string]: unknown;
}

async function fetchTaskByIdAndType(taskId: string, type: TaskType) {
  return await httpClient.tasks.get<TaskByIdAndTypeResponse>(
    `/v1/task/by-id-type`,
    {
      params: { taskId, type },
    }
  );
}

export function useGetTaskByIdAndType(taskId: string, type: TaskType) {
  return useQuery({
    queryKey: ["task", "id", taskId, type],
    queryFn: async () => await fetchTaskByIdAndType(taskId, type),
    staleTime: INTERVAL.MINUTE,
    enabled: !!taskId && !!type,
    retry: (failureCount, error: HttpError) =>
      error?.status !== 404 && failureCount < 3,
  });
}
